import * as React from "react";
import { RegisterOptions, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Switch, useTheme } from "react-native-paper";
import { Block } from "@block";
import { InputText } from "../input";
import { RESPONSEDATA } from "app/shared/services/services-model.type";
import { spacing } from "app/shared/styles/spacing";

interface FormAddBeneProps {
  isAddBene?: boolean;
  onPressSwitch?: Function;
  isBeneSaved?: boolean;
  accountBene?: { name?: string; value?: string };
  setBeneSaved?: Function;
  show?: boolean;
  responseCreate?: RESPONSEDATA;
  tempType?: string;
  beneNameDefault?: string;
  beneSearch?: string;
}

enum FormEnum {
  beneName,
}

type ValidDataSchemeFormData = {
  [key in keyof typeof FormEnum]: Omit<RegisterOptions, "valueAsNumber" | "valueAsDate" | "setValueAs">;
};

interface ConfirmData {
  beneName: string;
}

const FormAddBene = (props: FormAddBeneProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  const { show = false, isAddBene = false, onPressSwitch = () => {}, isBeneSaved = false, accountBene, beneNameDefault } = props;

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: { display: show ? "flex" : "none" },
        switchStyle: {
          position: "absolute",
          right: spacing.medium,
          bottom: 20,
          opacity: isBeneSaved ? 0.5 : 1,
        },
        inputDisplay: { display: show ? "flex" : "none", flex: 1, paddingRight: spacing.macro },
      }),
    [isBeneSaved, show],
  );

  const { control, setValue, getValues, reset } = useForm<ConfirmData>({
    defaultValues: {
      beneName: "",
    },
    mode: "onChange",
  });

  const validateSchemeForm: ValidDataSchemeFormData = {
    beneName: {
      required: {
        value: isAddBene,
        message: t("BENE_VUI_LONG_NHAP_TEN_GOI_NHO"),
      },
    },
  };

  const onToggleSwitch = () => {
    if (!isBeneSaved) {
      if (!isAddBene) {
        setValue("beneName", beneNameDefault || "");
        onPressSwitch(true, beneNameDefault);
      } else {
        reset();
        onPressSwitch(false, "");
      }
    }
  };

  // const getBene = React.useCallback(
  //   (response?: RESPONSEDATA, listBene?: TRANSPROFILE[]) => {
  //     switch (tempType) {
  //       case Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER:
  //       case Constant.TEMPLATE_TYPE.INTERBANK_TRANSFER:
  //       case Constant.TEMPLATE_TYPE.INTERBANK_FAST_TRANSFER:
  //       case Constant.TEMPLATE_TYPE.CASH_BY_CODE_TEMPLATE:
  //         return findAccountFromBene(response?.TRANSFER?.CREDIT_ACCOUNT_NUMBER, listBene);
  //       case Constant.TEMPLATE_TYPE.DEPOSIT_TO_STOCK_TRADE_ACCOUNT:
  //         return findAccountFromBene(beneSearch, listBene);
  //       case Constant.TEMPLATE_TYPE.TOP_UP_TEMPLATE:
  //       case Constant.TEMPLATE_TYPE.BILLING_TEMPLATE:
  //         return findTopUpBillingFromBene(response?.EBINQUIRY?.INQUIRY_CODE, listBene);
  //       default:
  //         return undefined;
  //     }
  //   },
  //   [beneSearch, tempType],
  // );

  const handlerBlurText = () => {
    onPressSwitch(isAddBene, getValues("beneName"));
  };

  React.useEffect(() => {
    if (isBeneSaved && accountBene?.name?.length && !isAddBene) {
      setValue("beneName", accountBene?.name || "");
      onPressSwitch(true, accountBene?.name || "");
    }
  }, [accountBene, isBeneSaved, isAddBene, onPressSwitch, setValue]);

  return (
    <Block display={show ? "flex" : "none"}>
      <InputText
        rules={validateSchemeForm.beneName}
        name={"beneName"}
        control={control}
        inputProps={{ editable: !isBeneSaved && isAddBene }}
        style={styles.inputDisplay}
        label={t("BENE_LUU_THU_HUONG")}
        onBlur={() => handlerBlurText()}
        rightContent={
          <Switch
            theme={{ colors: { accent: colors.accent } }}
            value={isAddBene}
            onValueChange={onToggleSwitch}
            style={styles.switchStyle}
            color={colors.accent}
          />
        }
      />
    </Block>
  );
};

export default FormAddBene;
